import React, { useEffect, useState } from "react";
import { createBrowserHistory } from "history";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { RoutesList } from "@shared/RoutesList";
import UserLayout from "./layout/UserLayout";
import Layout from "./layout/Layout";
import PrivateRoute from "@shared/PrivateRoute";
import ErrorPage from "@pages/Error";
import MaintenancePage from "@pages/MaintenancePage";

const renderSelf = (components) =>
  components.map((Component, key) => <Component key={key} />);

const renderComponent = (components, showSidemenu, isWizard) =>
  showSidemenu || isWizard ? (
    <UserLayout isWizard={isWizard}>{renderSelf(components)}</UserLayout>
  ) : (
    <Layout>{renderSelf(components)}</Layout>
  );

const history = createBrowserHistory();

const getUTCNow = () => {
  const now = new Date();
  return {
    hours: now.getUTCHours(),
    minutes: now.getUTCMinutes(),
    day: now.getUTCDate(),
    month: now.getUTCMonth() + 1, // Months are zero-based
    year: now.getUTCFullYear(),
  };
};

const shouldDisplayMaintenance = () => {
  const { hours, minutes, day, month, year } = getUTCNow();
  return (
    year === 2025 &&
    month === 5 &&
    day === 14 &&
    ((hours > 18 && hours < 22) ||
      (hours === 18 && minutes >= 0) ||
      (hours === 22 && minutes === 0))
  );
};

const AppRoute = () => {
  const [displayMaintenancePage, setDisplayMaintenancePage] = useState(
    shouldDisplayMaintenance()
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setDisplayMaintenancePage(shouldDisplayMaintenance());
    }, 60000); // Check every minute
    return () => clearInterval(interval);
  }, []);

  return (
    <Router history={history}>
      <Switch>
        {RoutesList.map(
          (
            {
              url: route,
              component: components,
              title: title,
              isWizard = false,
              showSidemenu = false,
            },
            index
          ) =>
            displayMaintenancePage ? (
              <MaintenancePage key={index} />
            ) : (
              <PrivateRoute
                location={location}
                exact
                path={`${route}`}
                component={() =>
                  renderComponent(components, showSidemenu, isWizard)
                }
                key={index}
                title={title}
              />
            )
        )}
        <Route
          component={displayMaintenancePage ? MaintenancePage : ErrorPage}
        />
      </Switch>
    </Router>
  );
};
export default AppRoute;
